import React from 'react';
import { Immutable } from 'nuclear-js';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';

import Actions from 'data/actions';
import BatchOptions from 'components/student-profile/student-heading/header-controls/print-and-share/batch-options/index';
import BatchUtils from 'components/student-profile/student-heading/header-controls/print-and-share/utils.js';
import RuntimeActions from 'data/app-runtime/actions';
import PropTypes from 'prop-types';

export default CreateReactClass({
    displayName: 'family-report',

    propTypes: {
        isSingleStudentMode: PropTypes.bool,
        linkingStudies: PropTypes.instanceOf(Immutable.List).isRequired,
        reportsQueueLink: PropTypes.string,
        selectedClass: PropTypes.instanceOf(Immutable.Map),
        selectedModule: PropTypes.string,
        selectedSubject: PropTypes.instanceOf(Immutable.Map),
        selectedTermNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        studentInfo: PropTypes.instanceOf(Immutable.List),
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        termsWithTestEvents: PropTypes.instanceOf(Immutable.List),
    },

    getInitialState() {
        return {
            batchOptionState: true,
            batchTab: 'class',
            canToggle: true,
            isFamilyReport: true,
            selectedPrintFormat: Immutable.Set(),
            selectedStudentForPrinting: 'all',
            studentOption: 'all',
            showBatchPrint: false,
            showPrintShare: false,
            studentPreviousSelection: 'all',
            visitedSections: Immutable.Set.of('class'), //Sections includes ('subjects', 'pages', 'students')
        };
    },

    componentDidMount() {
        Actions.roster.clearRosterData();
        this.setDefaultPrintFormatForFamilyReport();
    },

    setDefaultPrintFormatForFamilyReport() {
        // set 2 sided print to true (default)
        let format = this.state.selectedPrintFormat;
        format = format.add('page break').add('page break selected students');
        this.setState({
            selectedPrintFormat: format,
        });
    },

    nextButtonAction(event, source) {
        const { isFamilyReport } = this.state;
        if (isFamilyReport && source === 'pages') {
            source = 'students';
        }

        const newVisitedSections = this.state.visitedSections.add(source);

        this.setState({
            batchTab: source,
            visitedSections: newVisitedSections,
        });
    },

    togglePrintFormat(event, page) {
        let analyticsName;

        if (page == 'no test' || page == 'no test selected students') {
            analyticsName = 'include-no-test-events';
        }
        if (page == 'page break' || page == 'page break selected students') {
            analyticsName = '2-sided-printing';
        }
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, analyticsName);

        let format = this.state.selectedPrintFormat;
        if (format.includes(page)) {
            format = format.delete(page);
        } else {
            format = format.add(page);
        }
        this.setState({
            selectedPrintFormat: format,
        });
        this.selectFormat(format);
    },

    selectFormat(format) {
        this.setState({
            selectedPrintFormat: format,
        });
    },

    toggleStudentSelection(event, students) {
        let analyticsName;

        if (students == 'all') {
            analyticsName = 'all-students';
        } else {
            analyticsName = 'select-students';
        }
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'select-students', analyticsName);

        let previousSelection = this.state.selectedStudentForPrinting;
        this.setState({
            selectedStudentForPrinting: students,
            studentPreviousSelection: previousSelection,
        });
        this.selectStudents(students);
    },

    selectStudents(students) {
        this.setState({
            studentOption: students,
        });
    },

    togglePrintAndShare(event, printStatus = '') {
        const tab =
            printStatus == CommonStrings.batchPrint.printStatus.success ||
            printStatus == CommonStrings.batchPrint.printStatus.failure
                ? 'status'
                : 'class';
        const visited =
            printStatus == CommonStrings.batchPrint.printStatus.success ||
            printStatus == CommonStrings.batchPrint.printStatus.failure
                ? Immutable.Set()
                : Immutable.Set.of('class');
        this.setState({
            batchOptionState: true,
            batchTab: tab,
            canToggle: true,
            isFamilyReport: true,
            selectedPrintFormat: Immutable.Set(),
            showBatchPrint: false,
            showPrintShare: false,
            visitedSections: visited,
        });
        RuntimeActions.setPageAlert(
            Immutable.Map({
                messageContent: null,
                isActive: false,
                actionStatus: '',
            })
        );
    },

    render() {
        const displayPages = BatchUtils.displayPages;

        let studentOptionClass = `batch `;

        if (
            this.state.studentOption != null &&
            this.state.studentOption == 'choose' &&
            this.state.selectedStudentForPrinting == 'choose'
        ) {
            studentOptionClass += 'select-students ';
        } else if (this.state.studentOption == 'all' && this.state.selectedStudentForPrinting == 'all') {
            studentOptionClass += 'all-students ';
        }

        const panelClasses = studentOptionClass + this.state.batchTab + ' family-report';

        return (
            <div id="print-family-report" className={panelClasses}>
                <BatchOptions
                    batchOptionState={this.state.batchOptionState}
                    classSelected={this.props.classSelected}
                    batchTab={this.state.batchTab}
                    displayPages={displayPages}
                    dropDowns={this.props.dropDowns}
                    isFamilyReport={true}
                    isFamilyReportURL={true}
                    clearSelectedStudents={this.props.clearSelectedStudents}
                    setClearSelectedStudents={this.props.setClearSelectedStudents}
                    isSingleStudentMode={this.props.isSingleStudentMode}
                    linkingStudies={this.props.linkingStudies}
                    nextButtonAction={this.nextButtonAction}
                    reportQueueLink={this.props.reportsQueueLink}
                    selectedClass={this.props.selectedClass}
                    selectedModule={this.props.selectedModule}
                    selectedPrintFormat={this.state.selectedPrintFormat}
                    selectedStudentForPrinting={this.state.selectedStudentForPrinting}
                    selectedSubject={this.props.selectedSubject}
                    selectedTermNumber={this.props.selectedTermNumber}
                    selectFormat={this.selectFormat}
                    selectStudents={this.selectStudents}
                    studentInfo={this.props.studentInfo}
                    studentPreviousSelection={this.state.studentPreviousSelection}
                    students={this.props.students}
                    termsWithTestEvents={this.props.termsWithTestEvents}
                    togglePrintAndShare={this.togglePrintAndShare}
                    togglePrintFormat={this.togglePrintFormat}
                    toggleStudentSelection={this.toggleStudentSelection}
                    visitedSections={this.state.visitedSections}
                />
            </div>
        );
    },
});
